/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-08-30
 * @brief EHP ManageMent - ApprovalManageMent 개발
 *
 ********************************************************************/
import React from "react";
//
import NewSubscriberApprovalManageMnet from "./UserApproval";
import SiteApprovalManageMent from "./SiteApproval";
import CheckApprovalManageMent from "./CheckItemApproval";
/**
 * @brief EHP ManageMent - ApprovalManageMent 개발 컴포넌트, 반응형 동작
 * @param param0 width:<number>: 화면(브라우저) 가로 사이즈
 * @param param1 height:<number>: 화면(브라우저) 세로 사이즈
 * @returns react components
 */
function ApprovalMain(props) {
    //recoil
    //
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__left" },
            React.createElement(NewSubscriberApprovalManageMnet, { setPopWin: props.setPopWin })),
        React.createElement("div", { className: "area__right" },
            React.createElement(SiteApprovalManageMent, { setPopWin: props.setPopWin })),
        React.createElement("div", { className: "area__right-end" },
            React.createElement(CheckApprovalManageMent, { setPopWin: props.setPopWin }))));
}
;
export default ApprovalMain;
